export const redirectMixin = {
    data() {
        return {
            isAllowedOrigin: false
        }
    },
    methods: {
        redirectPage() {
            
            const isRedirect = this.$store.state.auth.redirect;
            const redirectTo = this.$store.state.auth.redirect_to;
            const allowedOrigins = this.$store.state.auth.allowedOrigins;

            if (isRedirect && redirectTo) {
                let targetUrl;
                try {
                    targetUrl = new URL(redirectTo);
                } catch (e) {
                    this.flashError('URL de redirecionamento inv�lida', "is-bottom", 5000);
                    return;
                }
        
                // Limpa a string de origens permitidas
                let cleanOrigins = allowedOrigins;
                
                // Remove colchetes se existirem
                cleanOrigins = cleanOrigins.replace(/[\[\]]/g, '');
                
                // Remove aspas se existirem
                cleanOrigins = cleanOrigins.replace(/"/g, '');
                
                // Divide por v�rgula e limpa cada URL
                const allowedOriginsArray = cleanOrigins.split(',')
                    .map(url => {
                        try {
                            // Tenta criar um objeto URL para extrair apenas o hostname
                            return new URL(url.trim()).hostname;
                        } catch (e) {
                            // Se falhar, retorna a URL limpa
                            return url.trim();
                        }
                    })
                    .filter(url => url); // Remove entradas vazias
                
        
                const targetHostname = targetUrl.hostname;
        
                // Verifica se o hostname alvo est� na lista de origens permitidas
                const isAllowed = allowedOriginsArray.some(allowedHost => allowedHost === targetHostname);
        
                if (isAllowed) {
                    this.isAllowedOrigin = true;
                } else {
                    this.flashError('Origem n�o permitida', "is-bottom", 5000);
                    return;
                }
            }
        
            if (this.isAllowedOrigin) {
                window.location.replace(redirectTo);
            } else {
                this.$router.push("/profile");
                this.flashSuccess("Login realizado com sucesso.", "is-bottom");
            }
        }
    }
}
